module.exports = __webpack_public_path__ + "static/card-cargo-owners-2-1c53943584352b87b767ee923265c518.jpg";